exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accessibility-font{font-size:1.5rem}.accessibility-greyscale{-moz-filter:grayscale(100%);filter:grayscale(100%);min-height:100vh}.accessibility-contrast{-moz-filter:invert(100%);filter:invert(100%);min-height:100vh}.accessibility-highlight-link{padding:3px;background-color:#000!important;color:#ff0!important;text-decoration:underline!important}", ""]);

// exports
